var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherMaterialIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "0.75vw",
    height: "0.75vw",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 4.375L6.25 1.875L13.125 4.375M1.875 4.375V7.5L8.75 10L13.125 7.5V4.375M1.875 4.375L8.75 6.875L13.125 4.375",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 7.5V10.625L8.75 13.125L13.125 10.625V7.5",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherMaterialIcon);
export default __webpack_public_path__ + "static/media/Other_Material_Icon.cc0f2d37b287fe2c4c8ec4e0b6cb30d6.svg";
export { ForwardRef as ReactComponent };